import { Modal } from "@mui/material";
import {
  AddOutlined,
  Close,
  DeleteOutlineOutlined,
  RequestQuoteOutlined,
} from "@mui/icons-material";
import { useState } from "react";
import Styles from "./UploadLDC.module.css";

const EMPTY_CHARGE = () => ({ name: "", value: "" });

const ChargeReqModal = ({ open, handleClose, handleSubmit }) => {
  const [charges, setCharges] = useState([EMPTY_CHARGE()]);

  const handleAdd = () => setCharges((prev) => [...prev, EMPTY_CHARGE()]);

  const handleChange = (index, field, value) => {
    setCharges((prev) =>
      prev.map((c, i) => (i === index ? { ...c, [field]: value } : c)),
    );
  };

  const handleDelete = (index) => {
    setCharges((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSend = () => {
    const valid = charges.filter((c) => c.name.trim() && c.value !== "");
    if (valid.length === 0) return;
    handleSubmit(valid);
    handleClose();
  };

  const total = charges.reduce((sum, c) => sum + (parseFloat(c.value) || 0), 0);
  const isValid = charges.some((c) => c.name.trim() && c.value !== "");

  return (
    <Modal open={open} onClose={handleClose}>
      <div className={`popupModal ${Styles.chargeAddReqModal}`}>
        {/* Header */}
        <div className={Styles.chargeReqHeading}>
          <div className={Styles.chargeReqHeadingLeft}>
            <div className={Styles.chargeReqIcon}>
              <RequestQuoteOutlined
                style={{ fontSize: 18, color: "#ff8800" }}
              />
            </div>
            <div>
              <div className={Styles.chargeReqTitle}>Add Charge Request</div>
              <div className={Styles.chargeReqSubtitle}>
                Charges not found in wallet will be sent for approval
              </div>
            </div>
          </div>
          <Close
            style={{ fontSize: 18, color: "#aaaaaa", cursor: "pointer" }}
            onClick={handleClose}
          />
        </div>

        {/* Column labels */}
        <div className={Styles.chargeReqColLabels}>
          <span style={{ flex: 1 }}>Charge Name</span>
          <span style={{ width: 80 }}>Amount (₹)</span>
          <span style={{ width: 28 }} />
        </div>

        {/* Charge rows */}
        <div className={`${Styles.chargeReqList} scroll_bar_y`}>
          {charges.map((charge, index) => (
            <div key={index} className={Styles.chargeReqRow}>
              <div style={{ flex: 1 }}>
                <input
                  className={Styles.chargeReqInput}
                  type="text"
                  placeholder="e.g. TRANSMISSION_CHARGES"
                  value={charge.name}
                  onChange={(e) => handleChange(index, "name", e.target.value)}
                />
              </div>
              <div style={{ width: 120 }}>
                <input
                  className={`${Styles.chargeReqInput} ${Styles.chargeReqInputAmount}`}
                  type="number"
                  placeholder="0.00"
                  value={charge.value}
                  onChange={(e) => handleChange(index, "value", e.target.value)}
                />
              </div>
              <div className={Styles.chargeReqDeleteCell}>
                <button
                  className={Styles.chargeReqDeleteBtn}
                  disabled={charges.length === 1}
                  onClick={() => handleDelete(index)}
                >
                  <DeleteOutlineOutlined style={{ fontSize: 16 }} />
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Add row + Total */}
        <div className={Styles.chargeReqMeta}>
          <div className={Styles.chargeReqTotal}>
            <span>Total</span>
            <span className={Styles.chargeReqTotalValue}>
              ₹{" "}
              {total.toLocaleString("en-IN", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </span>
          </div>
          <button className={Styles.chargeReqAddBtn} onClick={handleAdd}>
            <AddOutlined style={{ fontSize: 14 }} />
            Add Charge
          </button>
        </div>

        {/* Footer */}
        <div className={Styles.chargeReqFooter}>
          <div
            className={`activeButton_type_3 ${Styles.chargeReqBtn}`}
            onClick={handleClose}
          >
            Cancel
          </div>
          <div
            className={`${isValid ? "activeButton" : "activeButton_disable"} ${Styles.chargeReqBtn}`}
            onClick={isValid ? handleSend : undefined}
          >
            Send Request
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ChargeReqModal;
